/* ==========================================================================
   Supratec MX - front-end behaviors for sp- sections.
   Pixel-safe: never posts to the cart on its own. Cart actions always go
   through the theme's native <product-form> or native add-to-cart button.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lang = document.documentElement.lang || 'es';

  /* ---------- Money (uses the shop money format) ---------- */
  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    var format = window.SupratecMoneyFormat || '${{amount}}';
    var whole = cents % 100 === 0;
    function withDelims(num, precision, thousands, decimal) {
      var parts = (num / 100).toFixed(precision).split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return intPart + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, whole ? 0 : 2, "'", '.'); break;
      default: value = withDelims(cents, whole ? 0 : 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  window.spFormatMoney = formatMoney;

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sp-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Announcement rotation (mobile) ---------- */
  function initAnnouncement(root) {
    (root || document).querySelectorAll('[data-sp-rotate]').forEach(function (track) {
      if (track.dataset.spReady) return;
      track.dataset.spReady = '1';
      var items = track.querySelectorAll('.sp-ann__item');
      if (items.length < 2) return;
      var i = 0;
      var speed = (parseInt(track.dataset.spRotate, 10) || 4) * 1000;
      var mq = window.matchMedia('(max-width: 639px)');
      var paused = false;
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (!mq.matches || paused || document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Tabs ---------- */
  function activateTab(tabs, tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-sp-tabs]').forEach(function (wrap) {
      if (wrap.dataset.spReady) return;
      wrap.dataset.spReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activateTab(tabs, tab); });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          activateTab(tabs, next, true);
        });
      });
    });
  }

  /* ---------- Hero model finder ---------- */
  function initFinder(root) {
    (root || document).querySelectorAll('[data-sp-finder]').forEach(function (form) {
      if (form.dataset.spReady) return;
      form.dataset.spReady = '1';
      var dataEl = form.querySelector('[data-sp-finder-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var brand = form.querySelector('[data-sp-brand]');
      var model = form.querySelector('[data-sp-model]');
      var part = form.querySelector('[data-sp-part]');
      var msg = form.querySelector('[data-sp-finder-msg]');

      function sync(sel) {
        if (!sel) return;
        sel.classList.toggle('is-placeholder', sel.value === '');
        sel.parentElement.classList.toggle('is-set', sel.value !== '');
      }
      function fillModels() {
        var b = data[parseInt(brand.value, 10)] || { m: [] };
        model.innerHTML = '';
        model.add(new Option(model.dataset.placeholder || '', ''));
        b.m.forEach(function (m, i) { model.add(new Option(m.t, String(i))); });
        model.disabled = b.m.length === 0;
        sync(model);
      }

      brand.addEventListener('change', function () { fillModels(); if (msg) msg.textContent = ''; });
      model.addEventListener('change', function () { sync(model); if (msg) msg.textContent = ''; });
      if (part) part.addEventListener('change', function () { sync(part); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var b = data[parseInt(brand.value, 10)];
        if (!b) return;
        var url = b.u;
        if (model.value !== '' && b.m[parseInt(model.value, 10)]) url = b.m[parseInt(model.value, 10)].u;
        if (!url || url === '#') {
          if (msg) msg.textContent = form.dataset.error || '';
          model.focus();
          return;
        }
        if (part && part.value) {
          url += (url.indexOf('?') > -1 ? '&' : '?') + encodeURIComponent(form.dataset.param || 'filter.p.product_type') + '=' + encodeURIComponent(part.value);
        }
        window.location.href = url;
      });
    });
  }

  /* ---------- PDP: variant-aware labels ---------- */
  function mainProduct() { return document.querySelector('[data-section-type="main-product"]'); }

  function variantData() {
    var el = document.querySelector('[data-sp-variants]');
    if (!el) return null;
    if (!el._spData) {
      try { el._spData = JSON.parse(el.textContent); } catch (e) { el._spData = {}; }
    }
    return el._spData;
  }

  function currentVariantId() {
    var input = document.querySelector('[data-section-type="main-product"] .product_buy_button_form input[name="id"]') ||
      document.querySelector('[data-section-type="main-product"] form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? input.value : null;
  }

  function stockState(el, v) {
    var low = parseInt(el.dataset.low, 10) || 0;
    var showCount = el.dataset.showCount === 'true';
    if (!v.a) return { cls: 'out', txt: el.dataset.tOut };
    if (el.hasAttribute('data-stock-off')) return { cls: 'stock', txt: '' };
    if (v.t && low > 0 && v.q <= low) return { cls: 'low', txt: (el.dataset.tLast || '').replace('[n]', v.q) };
    if (v.t && showCount) return { cls: 'stock', txt: (el.dataset.tCount || '').replace('[n]', v.q) };
    return { cls: 'stock', txt: el.dataset.tIn };
  }

  function updateVariantUI() {
    var data = variantData();
    var id = currentVariantId();
    if (!data || !id || !data[id]) return;
    var v = data[id];

    document.querySelectorAll('[data-sp-stock-wrap]').forEach(function (wrap) {
      var st = stockState(wrap, v);
      if (!st.txt) { wrap.innerHTML = ''; return; }
      wrap.innerHTML = '<span class="sp-tag sp-tag--' + st.cls + '" data-sp-stock></span>';
      wrap.firstChild.textContent = st.txt;
    });
    document.querySelectorAll('[data-sp-sku]').forEach(function (el) {
      var val = el.querySelector('[data-sp-sku-value]');
      if (val) val.textContent = v.s || '';
      el.hidden = !v.s;
    });
    document.querySelectorAll('[data-sp-cta-stock]').forEach(function (el) {
      var txt = stockState(el, v).txt;
      el.textContent = txt;
      var sep = el.parentNode && el.parentNode.querySelector('[data-sp-cta-sep]');
      if (sep) sep.hidden = !txt;
    });
    document.querySelectorAll('[data-sp-cta-price]').forEach(function (el) { el.textContent = formatMoney(v.p); });
    document.querySelectorAll('[data-sp-msi]').forEach(function (el) {
      var months = parseInt(el.dataset.months, 10) || 6;
      var min = parseInt(el.dataset.min, 10) || 0;
      el.hidden = !v.p || v.p < min;
      var amt = el.querySelector('[data-sp-msi-amount]');
      if (amt) amt.textContent = formatMoney(Math.floor(v.p / months));
    });
    document.querySelectorAll('[data-sp-native-atc]').forEach(function (btn) { btn.disabled = !v.a; });
    document.querySelectorAll('[data-sp-bundle]').forEach(function (form) {
      form.dataset.mainPrice = v.p;
      var main = form.querySelector('[data-sp-bundle-main]');
      if (main) main.value = id;
      recalcBundle(form);
    });
  }

  document.addEventListener('change', function (e) {
    var mp = mainProduct();
    if (!mp || !mp.contains(e.target)) return;
    if (e.target.name === 'quantity') return;
    setTimeout(updateVariantUI, 150);
  });

  /* ---------- PDP: volume tiers <-> native quantity ---------- */
  function syncTiers(wrap, qty) {
    wrap.querySelectorAll('.sp-tier').forEach(function (tier) {
      var min = parseInt(tier.dataset.min, 10) || 1;
      var max = tier.dataset.max === '' ? Infinity : parseInt(tier.dataset.max, 10);
      var on = qty >= min && qty <= max;
      tier.classList.toggle('is-active', on);
      tier.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function initTiers(root) {
    (root || document).querySelectorAll('[data-sp-tiers]').forEach(function (wrap) {
      if (wrap.dataset.spReady) return;
      wrap.dataset.spReady = '1';
      var input = document.getElementById(wrap.dataset.qty);
      wrap.addEventListener('click', function (e) {
        var tier = e.target.closest('.sp-tier');
        if (!tier) return;
        var min = parseInt(tier.dataset.min, 10) || 1;
        if (input) {
          input.value = min;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncTiers(wrap, min);
      });
      if (input) {
        var onQty = function () { syncTiers(wrap, parseInt(input.value, 10) || 1); };
        input.addEventListener('change', onQty);
        input.addEventListener('input', onQty);
        var qtyWrap = input.closest('quantity-input');
        if (qtyWrap) qtyWrap.addEventListener('click', function () { setTimeout(onQty, 30); });
      }
    });
  }

  /* ---------- PDP: shipping cutoff (America/Mexico_City) ---------- */
  function mxToday() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false
    }).formatToParts(new Date());
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? parseInt(p.value, 10) : 0; };
    return { date: new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12)), hour: get('hour') % 24 };
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function isShipDay(d, sat) { var w = d.getUTCDay(); return (w >= 1 && w <= 5) || (sat && w === 6); }
  function addBusinessDays(d, n) {
    var x = d;
    while (n > 0) { x = addDays(x, 1); var w = x.getUTCDay(); if (w >= 1 && w <= 5) n--; }
    return x;
  }
  function fmtParts(d, opts) {
    var o = Object.assign({ timeZone: 'UTC' }, opts);
    var res = {};
    new Intl.DateTimeFormat(lang, o).formatToParts(d).forEach(function (p) { res[p.type] = p.value.replace(/\.$/, ''); });
    return res;
  }

  function initShipping(root) {
    (root || document).querySelectorAll('[data-sp-ship]').forEach(function (box) {
      try {
        var cutoff = parseInt(box.dataset.cutoff, 10) || 14;
        var sat = box.dataset.sat === 'true';
        var dMin = parseInt(box.dataset.min, 10) || 1;
        var dMax = Math.max(parseInt(box.dataset.max, 10) || dMin, dMin);
        var now = mxToday();
        if (box.dataset.mode === 'range') {
          var ra = fmtParts(addDays(now.date, dMin), { weekday: 'short', day: 'numeric', month: 'short' });
          var rb = fmtParts(addDays(now.date, dMax), { weekday: 'short', day: 'numeric', month: 'short' });
          var rr = ra.weekday + ' ' + ra.day + (ra.month !== rb.month ? ' ' + ra.month : '') + ' ' + String.fromCharCode(8211) + ' ' + rb.weekday + ' ' + rb.day + ' ' + rb.month;
          var rt = box.querySelector('[data-sp-ship-title]');
          if (rt) rt.textContent = (box.dataset.tToday || '').replace('[range]', rr);
          var re = box.querySelector('[data-sp-ship-eta]');
          if (re) re.textContent = '';
          return;
        }
        var ship = now.date;
        var shipsToday = isShipDay(ship, sat) && now.hour < cutoff;
        if (!shipsToday) {
          ship = addDays(ship, 1);
          while (!isShipDay(ship, sat)) ship = addDays(ship, 1);
        }
        var title = box.querySelector('[data-sp-ship-title]');
        if (title) {
          if (shipsToday) {
            title.textContent = box.dataset.tToday;
          } else {
            var sp = fmtParts(ship, { weekday: 'long', day: 'numeric' });
            title.textContent = (box.dataset.tNext || '').replace('[day]', sp.weekday + ' ' + sp.day);
          }
        }
        var eta = box.querySelector('[data-sp-ship-eta]');
        if (eta && box.dataset.tArrive) {
          var a = fmtParts(addBusinessDays(ship, dMin), { weekday: 'short', day: 'numeric', month: 'short' });
          var b = fmtParts(addBusinessDays(ship, dMax), { weekday: 'short', day: 'numeric', month: 'short' });
          var range = dMin === dMax
            ? a.weekday + ' ' + a.day + ' ' + a.month
            : a.weekday + ' ' + a.day + (a.month !== b.month ? ' ' + a.month : '') + ' ' + String.fromCharCode(8211) + ' ' + b.weekday + ' ' + b.day + ' ' + b.month;
          eta.textContent = box.dataset.tArrive.replace('[range]', range);
        }
      } catch (e) { /* keep server text */ }
    });
  }

  /* ---------- PDP: bundle (native product-form) ---------- */
  function recalcBundle(form) {
    var total = parseInt(form.dataset.mainPrice, 10) || 0;
    var n = 0;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
      var item = c.closest('.sp-bitem');
      if (item) item.classList.toggle('is-on', c.checked);
      if (c.checked) { total += parseInt(c.dataset.price, 10) || 0; n++; }
    });
    var totalEl = form.querySelector('[data-sp-bundle-total]');
    var labelEl = form.querySelector('[data-sp-bundle-label]');
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (labelEl && form.dataset.label) labelEl.textContent = form.dataset.label.replace('[n]', n);
  }

  function initBundle(root) {
    (root || document).querySelectorAll('[data-sp-bundle]').forEach(function (form) {
      if (form.dataset.spReady) return;
      form.dataset.spReady = '1';
      form.addEventListener('change', function () { recalcBundle(form); });
    });
  }

  /* Keep the bundle's main item on the variant selected in the native form. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-sp-bundle]')) return;
    var id = currentVariantId();
    var main = form.querySelector('[data-sp-bundle-main]');
    if (id && main) main.value = id;
  }, true);

  /* ---------- CTA -> native add to cart ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sp-native-atc]');
    if (!trigger) return;
    var atc = document.querySelector('[data-section-type="main-product"] .product_buy_button_form [name="add"]');
    if (!atc) return;
    atc.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    if (!atc.disabled) setTimeout(function () { atc.click(); }, reduceMotion ? 0 : 380);
  });

  /* ---------- Model grid: show all / show less ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-more]');
    if (!btn) return;
    var grid = document.getElementById(btn.getAttribute('aria-controls'));
    if (!grid) return;
    var open = !grid.classList.contains('is-expanded');
    grid.classList.toggle('is-expanded', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    if (!open) {
      var top = grid.getBoundingClientRect().top;
      if (top < 0) grid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* ---------- Video facade ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-video]');
    if (!btn) return;
    var url = btn.getAttribute('data-sp-video');
    var m;
    var src = '';
    if ((m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/))) {
      src = 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0';
    } else if ((m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/))) {
      src = 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    }
    if (!src) { window.open(url, '_blank', 'noopener'); return; }
    var box = document.createElement('div');
    box.className = 'sp-video';
    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = btn.getAttribute('aria-label') || '';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    box.appendChild(frame);
    btn.replaceWith(box);
  });

  /* ---------- Card "notify me" deep link -> native back-in-stock modal ---------- */
  function openNotify() {
    if (window.location.hash !== '#notify') return;
    var btn = document.getElementById('ProductPopup-notify');
    if (btn && btn.offsetParent !== null) setTimeout(function () { btn.click(); }, 500);
  }

  /* ---------- Init ---------- */
  function init(root) {
    initReveal(root);
    initAnnouncement(root);
    initTabs(root);
    initFinder(root);
    initTiers(root);
    initShipping(root);
    initBundle(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); openNotify(); });
  } else {
    init(document);
    openNotify();
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var tab = null;
    if (el.matches && el.matches('[role="tab"]')) tab = el;
    else if (el.matches && el.matches('[role="tabpanel"]')) tab = document.querySelector('[aria-controls="' + el.id + '"]');
    if (!tab) return;
    var wrap = tab.closest('[data-sp-tabs]');
    if (wrap) activateTab(Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]')), tab);
  });
})();
